// Главное действие экрана — одно. На сайте это наша полоса внизу экрана со строкой итога
// и кнопкой, в Mini App — нижняя кнопка Telegram: своей кнопки на экране тогда нет,
// а строка итога стоит в конце содержимого.
import { useEffect, useRef, type ReactNode } from "react";
import { Button } from "../ui/Button";
import screenStyles from "../ui/Screen.module.css";
import { useChannel } from "./channel";

type MainActionProps = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  // Действие выполняется: кнопка показывает ожидание и не нажимается повторно.
  busy?: boolean;
  // Строка над кнопкой: «Эльф · следопыт» и «бесплатно», «Миниатюра · серая» и цена.
  summary?: ReactNode;
};

export function MainAction({
  text,
  onClick,
  disabled = false,
  busy = false,
  summary,
}: MainActionProps) {
  const channel = useChannel();
  const latestClick = useRef(onClick);
  useEffect(() => {
    latestClick.current = onClick;
  }, [onClick]);

  const webApp = channel.kind === "telegram" ? channel.webApp : null;
  useEffect(() => {
    if (webApp === null) {
      return;
    }
    const handleClick = () => latestClick.current();
    webApp.MainButton.onClick(handleClick);
    return () => {
      webApp.MainButton.offClick(handleClick);
      webApp.MainButton.hide();
    };
  }, [webApp]);

  useEffect(() => {
    if (webApp === null) {
      return;
    }
    webApp.MainButton.setParams({ text, is_active: !disabled && !busy, is_visible: true });
    if (busy) {
      webApp.MainButton.showProgress(false);
    } else {
      webApp.MainButton.hideProgress();
    }
  }, [webApp, text, disabled, busy]);

  if (webApp !== null) {
    return summary === undefined ? null : (
      <div className={screenStyles.miniAppSummary}>{summary}</div>
    );
  }
  return (
    <div className={screenStyles.actionBar}>
      <div className={screenStyles.actionBarInner}>
        {summary !== undefined && <div className={screenStyles.summary}>{summary}</div>}
        <Button onClick={onClick} disabled={disabled} busy={busy}>
          {text}
        </Button>
      </div>
    </div>
  );
}
